import { Box, HStack, Separator, ShimmerText, VStack } from '@betterment/samba-react';

export const SupportCardShimmer = () => (
  <>
    <Separator />
    <HStack
      css={{
        gap: 'space.500',
        mt: 'space.400',
      }}
    >
      <Box
        css={{
          flex: 1,
        }}
      >
        <ShimmerText textStyle="title100" css={{ width: '120px', height: '12px', mb: 'space.200' }} />
        <ShimmerText textStyle="text100" css={{ width: '300px', height: '12px' }} />
      </Box>
      <VStack
        css={{
          flex: 1,
          alignItems: 'flex-start',
        }}
      >
        <ShimmerText textStyle="title100" css={{ width: '120px', height: '12px', mb: 'space.200' }} />
        <ShimmerText textStyle="text100" css={{ width: '300px', height: '12px' }} />
      </VStack>
    </HStack>
    <Separator />
    <HStack
      css={{
        gap: 'space.500',
        mt: 'space.400',
      }}
    >
      <Box
        css={{
          flex: 1,
        }}
      >
        <ShimmerText textStyle="title100" css={{ width: '120px', height: '12px', mb: 'space.200' }} />
        <ShimmerText textStyle="text100" css={{ width: '300px', height: '12px' }} />
      </Box>
      <VStack
        css={{
          flex: 1,
          alignItems: 'flex-start',
        }}
      >
        <ShimmerText textStyle="title100" css={{ width: '120px', height: '12px', mb: 'space.200' }} />
        <ShimmerText textStyle="text100" css={{ width: '300px', height: '12px', mb: 'space.200' }} />
        <ShimmerText textStyle="title100" css={{ width: '120px', height: '12px' }} />
      </VStack>
    </HStack>
  </>
);
